export const FRONTEND_LOG_FLUSH_MS = 2000;
export const FRONTEND_LOG_RETRY_MS = 30000;
export const FRONTEND_LOG_MAX_QUEUE = 100;
export const FRONTEND_LOG_MAX_BATCH_BYTES = 48 * 1024;
export const FRONTEND_LOG_MAX_BATCH_ENTRIES = 20;
export const FRONTEND_LOG_OPERATION_MESSAGE = /^[A-Za-z][A-Za-z0-9_]* - /;
export const FRONTEND_LOG_API_BASE_PATH = /^\/api\/otdata\/opslink\/?/;
export const FRONTEND_LOG_ERROR_TYPES = new Set([
  "Error",
  "TypeError",
  "RangeError",
  "SyntaxError",
  "ReferenceError",
  "URIError",
  "EvalError",
  "AggregateError",
  "AbortError",
  "NetworkError",
  "TimeoutError",
  "AxiosError",
  "CanceledError",
]);
export const FRONTEND_LOG_ERROR_CODES = new Set([
  "ERR_NETWORK",
  "ERR_CANCELED",
  "ERR_BAD_REQUEST",
  "ERR_BAD_RESPONSE",
  "ERR_INVALID_URL",
  "ECONNABORTED",
  "ECONNRESET",
  "ETIMEDOUT",
  "ENOTFOUND",
]);
export const FRONTEND_LOG_API_RESOURCES = new Set([
  "admin",
  "access-control",
  "accounts",
  "documents",
  "processing-tasks",
  "notifications",
  "voyage",
  "voyages",
  "voyagepnl",
  "voyage-pnl",
  "vessel",
  "vessels",
  "hull-cleaning",
  "hold-cleaning",
  "pbi",
  "user",
  "users",
  "user-prefs",
  "searchVessel",
  "getTQ",
  "tccodevoyagelist",
  "certificates",
  "crew-report",
  "vessel-info",
  "vessel-true-owner",
  "vesselRatings",
  "voyageAssesment",
  "voyageAssesmentStatus",
  "voyageCargoDetails",
  "voyageItinerary",
  "voyageMovementsPort",
  "voyagepnlapproval",
  "voyagepnlDriverDetails",
  "voyagepnlDrivers",
  "voyagepnlList",
  "voyagePosition",
  "voyageRealtimeStatus",
  "voyageSequenceItinerary",
  "userAddVessel",
  "userAssignedVessel",
  "userdelVessel",
  "portConsumptionDetails",
  "eco_speed_consumption",
  "cp_speed_consumption",
  "input_speed_consumption",
  "listDropDownVessels",
]);
export const FRONTEND_LOG_API_RESOURCE_PREFIXES = { bq_: "baltic-form", td_: "tech-form", tq_: "tech-form" };

export const FRONTEND_LOG_QUIET_REQUEST =
  /\/(?:processing-tasks\/[^/]+|refresh-status|refresh-runs\/[^/]+|documents\/presigned-url|hold-cleaning\/voyages\/[^/]+\/images)\/?$/;
